import React, { useState, useEffect, useMemo } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import Select from "react-select";
import redirectURL from "../redirectURL";
import "../../assets/css/inventorymanagement.css";

const WhSkuCategoryNorms = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [uniqueId, setUniqueId] = useState("");
  
  // Warehouse options (will be fetched from warehouse_master)
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  // Available categories for Add form
  const [availableCategories, setAvailableCategories] = useState([]);
  
  // Editable warehouse fields in form data
  const [editFormData, setEditFormData] = useState({
    Category: "",
    Type: "",
    Bhiwandi: "",
    Bangalore: "",
    Gurgaon: "",
    // Add more warehouse fields as needed
  });
  
  const [duplicatedEditData, setDuplicatedEditData] = useState({
    Category: "",
    Type: "",
    Bhiwandi: "",
    Bangalore: "",
    Gurgaon: "",
  });

  // Define column definitions
  const columnWithDefs = useMemo(() => [
    {
      headerName: "",
      field: "actions",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell", 
      cellRendererFramework: (params) => (
        <div
          style={{
            height: "36px", 
            padding: 0, 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center"
          }}
        >
          <button
            title="Edit"
            className="mt-2"
            style={{
              height: "30px", 
              width: "60px",
              padding: "0 10px",
              border: "1px solid #93385D",
              borderRadius: "4px",
              cursor: "pointer",
              backgroundColor: "#F4EBEF",
              fontSize: "0.8rem",
              color: "#93385D"
            }}
            onClick={() => handleEdit(params.data)}
          >
            Edit
          </button>
        </div>
      ),
    },
    {
      headerName: "",
      field: "delete",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell", 
      cellRendererFramework: (params) => (
        <div style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
            justifyContent: "center", 
            alignItems: "center"
        }}>
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params.data)}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    {
      headerName: "Category",
      field: "Category",
      sortable: true,
      resizable: true,
      flex: 1,
      filter: true
    },
    {
      headerName: "Type",
      field: "Type",
      sortable: true,
      resizable: true,
      flex: 1,
      filter: true
    },
    {
      headerName: "Bhiwandi",
      field: "Bhiwandi",
      sortable: true,
      resizable: true,
      flex: 1,
      valueFormatter: (params) => {
        return params.value 
      },
    },
    {
      headerName: "Bangalore",
      field: "Bangalore",
      sortable: true,
      resizable: true,
      flex: 1,
      valueFormatter: (params) => {
        return params.value 
      },
    },
    {
      headerName: "Gurgaon",
      field: "Gurgaon",
      sortable: true,
      resizable: true,
      flex: 1,
      valueFormatter: (params) => {
        return params.value 
      },
    }
  ], []);

  const resetFormData = () => {
    setEditFormData({ 
      Category: "",
      Type: "",
      Bhiwandi: "",
      Bangalore: "",
      Gurgaon: ""
    });
    
    setDuplicatedEditData({
      Category: "",
      Type: "",
      Bhiwandi: "",
      Bangalore: "",
      Gurgaon: ""
    });
  };

  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const onClickAddNewNorms = async () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Add New Category Norms");
    setOverlyBlock("show-m");
  };

  const handleEdit = (row) => {
    setSliderOpen(true);
    setSliderType(3); 
    setSliderCl("slider-25");
    setSliderTitle(`Edit Category Norms - ${row.Category}`);
    setOverlyBlock("show-m");
    setUniqueId(row._id);
    
    setEditFormData({
      Category: row.Category || "",
      Type: row.Type || "",
      Bhiwandi: row.Bhiwandi !== undefined ? row.Bhiwandi.toString() : "",
      Bangalore: row.Bangalore !== undefined ? row.Bangalore.toString() : "",
      Gurgaon: row.Gurgaon !== undefined ? row.Gurgaon.toString() : ""
    });

    setDuplicatedEditData({
      Category: row.Category || "",
      Type: row.Type || "",
      Bhiwandi: row.Bhiwandi !== undefined ? row.Bhiwandi.toString() : "",
      Bangalore: row.Bangalore !== undefined ? row.Bangalore.toString() : "",
      Gurgaon: row.Gurgaon !== undefined ? row.Gurgaon.toString() : ""
    });
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setUniqueId(row._id);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  const statusPanel = {
    statusPanels: [
      { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
      { statusPanel: "agTotalRowCountComponent", align: "center" },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    pivot: true,
    enableValue: true,
    enableRowGroup: true,
    resizable: true,
  };

  // Get WH SKU Category Norms data
  const getCategoryNormsData = async () => {
    try {
      const response = await redirectURL.post("masters/getWhSkuCategoryNorms", {});
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
        } else {
          setBasicTitle("No Category Norms data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching Category Norms data:", error);
      setBasicTitle("Failed to fetch Category Norms data");
      setBasicType("error");
      setShow(true);
    }
  };

  // Get warehouse list from warehouse_master (for reference)
  const getWarehouseList = async () => {
    try {
      const response = await redirectURL.post("masters/getWarehouseList", {});
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setWarehouseOptions(response.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching warehouse list:", error);
    }
  };

  // Get categories not in wh_sku_category_norms for Add form
  const getAvailableCategories = async () => {
    try {
      const response = await redirectURL.post("masters/getAvailableCategoriesForNorms", {});
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          const options = response.data.data.map(item => ({
            label: item,
            value: item
          }));
          setAvailableCategories(options);
        } else {
          setAvailableCategories([]);
        }
      }
    } catch (error) {
      console.error("Error fetching available categories:", error);
    }
  };

  useEffect(() => {
    const getData = async () => {
      setLoadshow("show-m");  
      setOverlayBlock("show-m");
      await getWarehouseList();
      await getCategoryNormsData();
      await getAvailableCategories();
      setLoadshow("show-n");  
      setOverlayBlock("show-n");
    };
    getData();
  }, []);

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setSliderOpen(false);
    setShowDeletePopup(false);
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  // Function To Trigger User Action
  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  };

  const handleAddCategoryNorms = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    // Prepare data for submission
    const params = {
      Category: editFormData.Category,
      Type: editFormData.Type,
      Bhiwandi: editFormData.Bhiwandi ? parseFloat(editFormData.Bhiwandi) : null,
      Bangalore: editFormData.Bangalore ? parseFloat(editFormData.Bangalore) : null,
      Gurgaon: editFormData.Gurgaon ? parseFloat(editFormData.Gurgaon) : null
    };

    // Validate required fields
    const validationErrors = [];
    if (!editFormData.Category) validationErrors.push("Category");
    if (!editFormData.Type) validationErrors.push("Type");
    
    // Validate at least one warehouse value
    const hasWarehouseValue = 
      editFormData.Bhiwandi !== "" || 
      editFormData.Bangalore !== "" || 
      editFormData.Gurgaon !== "";

    if (!hasWarehouseValue) validationErrors.push("at least one warehouse norm");

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in: ${validationErrors.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post(
        "masters/addNewWhSkuCategoryNorms",
        params
      );
   
      if (response.status === 200 && response.data.status === "success") {
        await getCategoryNormsData();
        // Refresh available categories
        await getAvailableCategories();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("New Category Norms Added Successfully");

        // User Action Triggering
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New WH SKU Category Norms",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);

        // Close slider
        hideOverlySlideBlock();
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message || "Failed to add Category Norms");
        
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Added New WH SKU Category Norms",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
     
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to add New Category Norms");

      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Added New WH SKU Category Norms",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const handleUpdateCategoryNorms = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    // Prepare data for update
    const updateData = {
      Type: editFormData.Type,
      Bhiwandi: editFormData.Bhiwandi ? parseFloat(editFormData.Bhiwandi) : null,
      Bangalore: editFormData.Bangalore ? parseFloat(editFormData.Bangalore) : null,
      Gurgaon: editFormData.Gurgaon ? parseFloat(editFormData.Gurgaon) : null
    };

    const params = {
      unique_id: uniqueId,
      data: updateData
    };

    // Check if any changes were made
    const isNeedtoUpdate = 
      duplicatedEditData.Type !== editFormData.Type ||
      duplicatedEditData.Bhiwandi !== editFormData.Bhiwandi ||
      duplicatedEditData.Bangalore !== editFormData.Bangalore ||
      duplicatedEditData.Gurgaon !== editFormData.Gurgaon;

    if (!isNeedtoUpdate) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("No changes made to category norms");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post(
        "masters/updateWhSkuCategoryNorms",
        params
      );

      if (response.data.status === "success") {
        await getCategoryNormsData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("Category Norms updated successfully");

        // User Action Triggering
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Updated WH SKU Category Norms",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);

        // Close slider
        hideOverlySlideBlock();
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message || "Failed to update category norms");

        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Updated WH SKU Category Norms",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
      
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to update Category Norms");

      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Updated WH SKU Category Norms",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    const params = { unique_id: uniqueId };
    try { 
      const response = await redirectURL.post(
        "masters/deleteWhSkuCategoryNorms",
        params
      );
    
      if (response.data.status === "success") {
        await getCategoryNormsData();
        // Refresh available categories
        await getAvailableCategories();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("Category Norms Deleted Successfully");
        
        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted WH SKU Category Norms",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete Category Norms");

        var userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "Deleted WH SKU Category Norms",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete Category Norms");
      
      var userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "Deleted WH SKU Category Norms",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  // Handle input change
  const handleInputChange = (field, value) => {
    setEditFormData({
      ...editFormData,
      [field]: value
    });
  };

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          >
          </SweetAlert>
        </div>

        <div className="row" style={{fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif"}}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{color : "#B9366D", fontSize : "18px", fontWeight : "bold", fontFamily : "sans-serif"}}>WH SKU Category Norms Master</h1>
          </div>
          <div style={addButtonContainerStyle} className="col-sm-12 text-right pr-0 mb-4">
            <button 
              onClick={onClickAddNewNorms}
              style={{
                ...addButtonStyle,
                backgroundColor: "#93385D",
                color: "#fff",
                border: "2px solid #93385D",
                marginRight : 15
              }}
            >
              <IoMdAdd style={{color : "#fff", fontSize :"18px"}}/>
              {" Add"}
            </button>
          </div>
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                // pagination={true}
                // paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{
                  suppressHorizontalScroll: false
                }}
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Slider for Add/Edit */}
      <div
  className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
  style={{ width: "25%" }}
>
  <div className="slider-header-container d-flex justify-content-between">
    <p className="m-0p">{sliderTitle}</p>
    <p
      className="m-0p"
      style={{ cursor: "pointer" }}
      onClick={onClickingSliderCloseIcon}
    >
      X&nbsp;&nbsp;&nbsp;
    </p>
  </div>

  {sliderType === 1 && (
    <form style={{ padding: "20px" }}>
      {/* Category Select */}
      <div className="form-group">
        <label
          htmlFor="category"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Category<span style={{ color: "red" }}>{" *"}</span>
        </label>
        <div id="category">
          <Select
            options={availableCategories}
            placeholder="Select Category"
            value={
              editFormData.Category
                ? {
                    label: editFormData.Category,
                    value: editFormData.Category,
                  }
                : null
            }
            onChange={(option) => handleInputChange("Category", option.value)}
            isSearchable
            required
          />
          {availableCategories.length === 0 && (
            <p style={{ color: "red", fontSize: "0.8rem", marginTop: "5px" }}>
              All categories already have norms defined
            </p>
          )}
        </div>
      </div>

      {/* Type Select */}
      <div className="form-group">
        <label
          htmlFor="type"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Type<span style={{ color: "red" }}>{" *"}</span>
        </label>
        <div id="type">
          <Select
            options={[
              { label: "In Warehouse", value: "In Warehouse" },
              { label: "Overall", value: "Overall" },
            ]}
            placeholder="Select Type"
            value={
              editFormData.Type
                ? {
                    label: editFormData.Type,
                    value: editFormData.Type,
                  }
                : null
            }
            onChange={(option) => handleInputChange("Type", option.value)}
            required
          />
        </div>
      </div>

      {/* Bhiwandi Input */}
      <div className="form-group">
        <label
          htmlFor="bhiwandi"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Bhiwandi
        </label>
        <input
          type="number"
          step="0.1"
          min="0"
          className="form-control"
          id="bhiwandi"
          value={editFormData.Bhiwandi}
          onChange={(e) => {
            const value = e.target.value;
            // Only accept positive numbers (including 0)
            if (value === "" || parseFloat(value) >= 0) {
              handleInputChange("Bhiwandi", value);
            }
          }}
          onKeyPress={(e) => {
            // Prevent negative sign, 'e', 'E', '+'
            if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
              e.preventDefault();
            }
          }}
          placeholder="Enter norm value"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
          }}
        />
      </div>

      {/* Bangalore Input */}
      <div className="form-group">
        <label
          htmlFor="bangalore"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Bangalore
        </label>
        <input
          type="number"
          step="0.1"
          min="0"
          className="form-control"
          id="bangalore"
          value={editFormData.Bangalore}
          onChange={(e) => {
            const value = e.target.value;
            // Only accept positive numbers (including 0)
            if (value === "" || parseFloat(value) >= 0) {
              handleInputChange("Bangalore", value);
            }
          }}
          onKeyPress={(e) => {
            // Prevent negative sign, 'e', 'E', '+'
            if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
              e.preventDefault();
            }
          }}
          placeholder="Enter norm value"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
          }}
        />
      </div>

      {/* Gurgaon Input */}
      <div className="form-group">
        <label
          htmlFor="gurgaon"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Gurgaon
        </label>
        <input
          type="number"
          step="0.1"
          min="0"
          className="form-control"
          id="gurgaon"
          value={editFormData.Gurgaon}
          onChange={(e) => {
            const value = e.target.value;
            // Only accept positive numbers (including 0)
            if (value === "" || parseFloat(value) >= 0) {
              handleInputChange("Gurgaon", value);
            }
          }}
          onKeyPress={(e) => {
            // Prevent negative sign, 'e', 'E', '+'
            if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
              e.preventDefault();
            }
          }}
          placeholder="Enter norm value"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
          }}
        />
      </div>

      {/* Add Button */}
      <div style={{ textAlign: "right", marginTop: "20px" }}>
        <button
          type="button"
          id="add-category-norms-button"
          onClick={handleAddCategoryNorms}
          disabled={availableCategories.length === 0}
          style={{
            padding: "8px 20px",
            backgroundColor: availableCategories.length === 0 ? "#ccc" : "#93385D",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: availableCategories.length === 0 ? "not-allowed" : "pointer",
            fontSize: "0.8rem",
          }}
        >
          ADD
        </button>
      </div>
    </form>
  )}

  {sliderType === 3 && (
    <form
      style={{ padding: "20px" }}
      onSubmit={(e) => {
        e.preventDefault();
        handleUpdateCategoryNorms();
      }}
    >
      {/* Category (Read-only) */}
      <div className="form-group">
        <label
          htmlFor="category"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Category
        </label>
        <input
          type="text"
          className="form-control"
          id="category"
          value={editFormData.Category}
          readOnly
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
            backgroundColor: "#a3a0a1",
            cursor: "not-allowed",
          }}
        />
      </div>

      {/* Type Select */}
      <div className="form-group">
        <label
          htmlFor="type"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Type<span style={{ color: "red" }}>{" *"}</span>
        </label>
        <div id="type">
          <Select
            options={[
              { label: "In Warehouse", value: "In Warehouse" },
              { label: "Overall", value: "Overall" },
            ]}
            value={
              editFormData.Type
                ? {
                    label: editFormData.Type,
                    value: editFormData.Type,
                  }
                : null
            }
            onChange={(option) => handleInputChange("Type", option.value)}
            required
          />
        </div>
      </div>

      {/* Bhiwandi Input */}
      <div className="form-group">
        <label
          htmlFor="bhiwandi"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Bhiwandi
        </label>
        <input
          type="number"
          step="0.1"
          min="0"
          className="form-control"
          id="bhiwandi"
          value={editFormData.Bhiwandi}
          onChange={(e) => {
            const value = e.target.value;
            // Only accept positive numbers (including 0)
            if (value === "" || parseFloat(value) >= 0) {
              handleInputChange("Bhiwandi", value);
            }
          }}
          onKeyPress={(e) => {
            // Prevent negative sign, 'e', 'E', '+'
            if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
              e.preventDefault();
            }
          }}
          placeholder="Enter norm value"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
          }}
        />
      </div>

      {/* Bangalore Input */}
      <div className="form-group">
        <label
          htmlFor="bangalore"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Bangalore
        </label>
        <input
          type="number"
          step="0.1"
          min="0"
          className="form-control"
          id="bangalore"
          value={editFormData.Bangalore}
          onChange={(e) => {
            const value = e.target.value;
            // Only accept positive numbers (including 0)
            if (value === "" || parseFloat(value) >= 0) {
              handleInputChange("Bangalore", value);
            }
          }}
          onKeyPress={(e) => {
            // Prevent negative sign, 'e', 'E', '+'
            if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
              e.preventDefault();
            }
          }}
          placeholder="Enter norm value"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
          }}
        />
      </div>

      {/* Gurgaon Input */}
      <div className="form-group">
        <label
          htmlFor="gurgaon"
          style={{
            fontSize: "0.9rem",
            fontWeight: "bold",
            color: "#333",
            marginBottom: "5px",
            display: "block",
          }}
        >
          Gurgaon
        </label>
        <input
          type="number"
          step="0.1"
          min="0"
          className="form-control"
          id="gurgaon"
          value={editFormData.Gurgaon}
          onChange={(e) => {
            const value = e.target.value;
            // Only accept positive numbers (including 0)
            if (value === "" || parseFloat(value) >= 0) {
              handleInputChange("Gurgaon", value);
            }
          }}
          onKeyPress={(e) => {
            // Prevent negative sign, 'e', 'E', '+'
            if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
              e.preventDefault();
            }
          }}
          placeholder="Enter norm value"
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "0.9rem",
          }}
        />
      </div>

      <div style={addButtonContainerStyle}>
        <button
          type="submit"
          id="update-category-norms-button"
          style={{
            padding: "8px 20px",
            backgroundColor: "#93385D",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "0.8rem",
          }}
        >
          Update
        </button>
      </div>
    </form>
  )}
</div>

      {/* Delete Popup */}
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            top: "40%",
            left: "30%",
            zIndex: "1003",
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            padding: "20px",
            borderRadius: "10px",
          }}
        >
          <div className="inventory-delete-popup">
            <p
              style={{
                color: "grey",
                fontSize: "19px",
                textAlign: "center",
                fontWeight: "bold",
                marginBottom: "20px",
              }}
            >
              {`Are you sure you want to delete ${selectedRow ? selectedRow.Category + " - " + selectedRow.Type : ""} Category Norms ?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button
                className="btn btn-danger"
                onClick={onClickingPopupDeleteBtn}
              >
                Delete
              </button>
              <button
                className="btn btn-secondary"
                onClick={onClickDeletePopupCancelBtn}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div style={{ zIndex: 997 }} className={`overlay-block ${overlayBlock}`}></div>
      <div
        className={"overly-block " + overlyBlock}
        onClick={hideOverlySlideBlock}
      >
      </div>
    </>
  );
};

const addButtonContainerStyle = { textAlign: "right", marginTop: "10px" };
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily :"sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
};

export default WhSkuCategoryNorms;